export interface NavigationItem {
  label: string
  to: string
  icon: string
  scopes: string[]
}

export interface NavigationGroup {
  label: string
  items: NavigationItem[]
}

export const navigation: NavigationGroup[] = [
  {
    label: 'Operaciones',
    items: [
      { label: 'Resumen', to: '/', icon: '⌁', scopes: ['dsp.cases:read'] },
      { label: 'Casos', to: '/cases', icon: '◇', scopes: ['dsp.cases:read'] },
      { label: 'Tareas', to: '/tasks', icon: '✓', scopes: ['dsp.tasks:read'] },
      { label: 'Clientes', to: '/customers', icon: '◎', scopes: ['dsp.customers:read'] },
      { label: 'Eventos', to: '/events', icon: '↯', scopes: ['dsp.events:read'] },
    ],
  },
  {
    label: 'Automatización',
    items: [
      { label: 'Playbooks', to: '/automation', icon: '⌘', scopes: ['dsp.playbooks:manage'] },
      { label: 'Ejecuciones', to: '/runs', icon: '⟳', scopes: ['dsp.automation:read'] },
    ],
  },
  {
    label: 'Canales',
    items: [
      {
        label: 'Comunicaciones',
        to: '/communications',
        icon: '◌',
        scopes: ['dsp.communications:read'],
      },
      {
        label: 'Integraciones',
        to: '/integrations',
        icon: '⇄',
        scopes: ['dsp.sources:manage', 'dsp.webhooks:manage', 'dsp.webhooks:read'],
      },
    ],
  },
  {
    label: 'Gobierno',
    items: [
      { label: 'Políticas', to: '/policies', icon: '◈', scopes: ['dsp.playbooks:manage'] },
      {
        label: 'Configuración',
        to: '/settings',
        icon: '⚙',
        scopes: [
          'dsp.credentials:read',
          'dsp.credentials:write',
          'dsp.playbooks:manage',
          'dsp.audit:read',
          'dsp.usage:read',
        ],
      },
    ],
  },
]
